import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError, withLatestFrom, map } from 'rxjs/operators';

import * as fromRoot from '../../store';
import * as fromStore from '../store';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class InitCustomerTokenGuard {
  private store = inject(Store);

  canActivate(): Observable<boolean> {
    return this.checkStore().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  checkStore(): Observable<boolean> {
    return this.store.select(fromStore.getTokenInitialized).pipe(
      tap(loaded => {
        if (!loaded) {
          this.store.dispatch(fromStore.InitCustomerAccessToken());
        }
      }),
      filter((loaded: boolean) => loaded),
      take(1)
    );
  }
}
